.card {
  position: sticky;
  top: 24px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  padding: 22px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.heading {
  text-align: center;
  margin: 0 0 6px;
  font-family: var(--font-display);
  font-size: 1.4rem;
  font-weight: 800;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.subtotalRow {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-size: 0.92rem;
  font-weight: 700;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  padding-top: 14px;
}

.subtotalRow strong { font-size: 1.1rem; }

.subtotalNote {
  font-size: 0.78rem;
  color: var(--color-ink-soft);
  margin-top: -8px;
}

.financing {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 6px;
  background: var(--color-bone);
  padding: 8px 10px;
  border-radius: 6px;
  font-size: 0.82rem;
}

.financingPill {
  background: rgba(102, 67, 219, 0.14);
  color: #4928bd;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.72rem;
}

.financing em { font-style: normal; font-weight: 700; color: var(--color-ink); }
.financingLink {
  color: var(--color-ember-dark);
  text-decoration: underline;
  margin-left: auto;
  font-size: 0.78rem;
}

.acc {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  overflow: hidden;
}

.accHead {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border: 0;
  padding: 12px 14px;
  cursor: pointer;
  font: inherit;
  font-size: 0.92rem;
  font-weight: 600;
}

.accTitle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.accBody {
  padding: 12px 14px 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.muted { color: var(--color-ink-soft); margin: 0; font-size: 0.85rem; }

.estimateForm {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.input {
  border: 1px solid rgba(0, 0, 0, 0.18);
  background: #fff;
  padding: 10px 12px;
  font: inherit;
  font-size: 0.9rem;
  border-radius: 4px;
  outline: none;
}

.input:focus { border-color: var(--color-ember); box-shadow: 0 0 0 3px rgba(243,154,46,0.18); }

.btnDark {
  background: #4a4441;
  color: #fff;
  border: 0;
  padding: 12px 14px;
  font: inherit;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  cursor: pointer;
  border-radius: 4px;
}

.btnDark:hover { background: #2c2825; }

.estimateResult {
  font-size: 0.85rem;
  color: var(--color-ink);
  background: rgba(46, 157, 87, 0.08);
  border-radius: 4px;
  padding: 8px 10px;
}

.checkoutBtn {
  margin-top: 4px;
  background: var(--color-ember);
  color: #111;
  border: 0;
  padding: 16px;
  font: inherit;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  cursor: pointer;
  border-radius: 4px;
}

.checkoutBtn:hover { background: var(--color-ember-dark); color: #fff; }
.checkoutBtn:disabled { opacity: 0.6; cursor: not-allowed; }
